import React, { useState } from 'react';

import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { getSubscriptionPlansClient } from 'services/payments';
import { premiumFeatureInfo } from 'constants/premium-features.const';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import IconButton from '@mui/material/IconButton';

import LinkButton from '@core/components/linkbutton/LinkButton';

import CloseIcon from 'assets/icons/close-icon.svg';
import { Star } from 'iconsax-react';

import classes from './PremiumFeatureModal.module.scss';




const PremiumFeatureModal = ({ closeHandler, featureName }) => {
    const [activeTab, setActiveTab] = useState('career');
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const router = useRouter();
    const { data, isLoading, error } = useQuery(['get-subscription-plans'], getSubscriptionPlansClient, {
        onError: (e) => {
            if (e.response.status === 404) {
                router.replace('/404');
            }
        }
    });
    const sx = {
        '&.MuiButtonBase-root': {
            fontSize: '14px',
            fontWeight: '400',
        },
        '&.Mui-selected': {
            fontSize: '14px',
            fontWeight: '700'
        }
    };
    return (
        <div className={classes['wrapper']}>
            <div className={classes['header']}>
                <div className={classes['close-wrapper']}>
                    <IconButton onClick={closeHandler}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className='d-flex align-items-center justify-content-center gap-3'>
                    <Star size={67} color='#FAA61A' className='d-none d-md-block' />
                    <div>
                        <h3>{premiumFeatureInfo[featureName]?.title}</h3>
                        <p>{premiumFeatureInfo[featureName]?.description}</p>
                    </div>
                </div>
            </div>
            <div className={classes['body']}>
                <h2>Unlock Pharmuni Premium Benefits !</h2>
                <p>Build your pharmaceutical career and expand your knowledge with advanced tools and personalized support! </p>
                <div className={classes['tab-wrapper']}>
                    <Box sx={{ minHeight: '300px', maxWidth: '650px', width: '100%', typography: 'body1', marginBottom: '20px' }}>
                        <TabContext value={activeTab}>
                            <Box sx={{ marginTop: '10px', justifyContent: 'center' }}>
                                <TabList onChange={handleChange} className={classes['tab-list']} >
                                    <Tab sx={sx} label="Career" value="career" />
                                    <Tab sx={sx} label="Learn" value="learn" />
                                </TabList>
                            </Box>
                            <TabPanel sx={{paddingBottom: '0'}} value="career">
                                <div className='row'>
                                    <div className='col-md-6 col-12'>
                                        <h5>Personalized Career Coaching </h5>
                                        <p>Get guidance from experts to accelerate your career growth and achieve your professional goals. </p>

                                        <h5 className='mt-0 mt-md-5'>AI-Powered Progress Monitoring  </h5>
                                        <p>Track your development with our AI-based Skill Tree and stay focused on enhancing your key competencies.  </p>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <h5>Professional Resume & Cover Letter Builder   </h5>
                                        <p>Build a professional resume and cover letter with pre-built templates to showcase your skills and stand out to employers</p>

                                        <h5 className='mt-0 mt-md-5'>Track Your Job Applications  </h5>
                                        <p>Organize and monitor all your job applications in one place to streamline your application process </p>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel  value="learn">
                                <div className='row'>
                                    <div className='col-md-6 col-12'>
                                        <h5>Full Access to All Course Content </h5>
                                        <p>Gain entry to specialized training on GMP, QMS, and compliance, keeping you at the forefront of pharmaceutical expertise.</p>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <h5>Pharmuni Certifications </h5>
                                        <p>Gain certifications that validate your expertise and boost your credibility in the pharmaceutical industry. </p>
                                    </div>
                                </div>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>
                <div className={classes['footer']}>
                    <div className='row'>
                        <div className='col-md-8 col-12 d-flex flex-column justify-content-center'>
                            {data && !isLoading && (
                                <div className={classes['price-wrapper']}>
                                    <div>
                                        {data.data.yearly.discounted_price ? data.data.yearly.discounted_price : data.data.yearly.price}{data.data.yearly.currency.symbol}/ month
                                        <h5>Billed annually</h5>
                                    </div>
                                    <div>
                                        {data.data.monthly.discounted_price ? data.data.monthly.discounted_price : data.data.monthly.price}{data.data.monthly.currency.symbol}/ month
                                        <h5>Billed monthly</h5>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='col-md-4 col-12 d-flex justify-content-end'>
                            <LinkButton kind='primary-color' to={'/plans'}>
                                Go Premium
                            </LinkButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PremiumFeatureModal;